import { jsx } from "react/jsx-runtime";
import { CloseIcon } from "../../icons/CloseIcon.js";
import { Button } from "./Button.js";
const CloseButton = ({ iconSize = 20, ...props }) => {
  return /* @__PURE__ */ jsx(
    Button,
    {
      "aria-label": "close",
      color: "default",
      variant: "icon",
      increaseSpecificity: true,
      sx: {
        width: iconSize * 2,
        height: iconSize * 2
      },
      ...props,
      children: /* @__PURE__ */ jsx(
        CloseIcon,
        {
          sx: {
            fontSize: iconSize
          }
        }
      )
    }
  );
};
export {
  CloseButton
};
//# sourceMappingURL=CloseButton.js.map
